export const makeLabel = "Make";
export const makeName = "Make Name";
export const addMakeLabel = "Add Make";
export const editMakeLabel = "Edit Make";
